import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { LockAndDownloadAction } from "actions/ocplcAction";
import { useDispatch } from "react-redux";

const LockAndDownloadDialog = ({ open, setOpen, handleClose, checkedRows, setCheckedRows, region, loginUserEmailId, selectedCategory, selectKmat, productGroup, selectedIds, setSelectedIds, setisLoading }) => {
  const dispatch = useDispatch();

  const handleDialogClose = () => {
    setOpen((prevState) => ({ ...prevState, lockanddownload: false }));
    handleClose();
  };

  const handleLockAndDownload = () => {
    dispatch(LockAndDownloadAction(checkedRows, handleDialogClose, setCheckedRows, region, loginUserEmailId, selectedCategory, selectKmat, productGroup, setSelectedIds, setisLoading));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: { borderRadius: 10, width: 520, padding: 7, margin: 0 },
      }}
    >
      <DialogTitle> Lock and Download </DialogTitle>
      <DialogContent>
        Are you sure you want to lock and download the selected items?
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "flex-start" }}>
        <Button
          sx={{ marginLeft: "15px" }}
          className="cancel-button"
          variant="outlined"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          className="add-Button"
          variant="contained"
          onClick={handleLockAndDownload}
           sx={{ backgroundColor: '#0278ab !important' }}
        >
          Lock and Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LockAndDownloadDialog;
